export default "__VITE_ASSET__ClLMvkil__"